var React = require('react');

function IconBetBuilder (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"m21 7-9-5-9 5v10l9 5 9-5V7zm-8.611-2.7a.808.808 0 0 0-.777 0L4.8 8.043v.027l6.824 3.897a.808.808 0 0 0 .8 0l6.776-3.87v-.054L12.389 4.3zM19.2 9.925l-1.6.914v1.97l1.36-.776a.802.802 0 0 1 .24-.09V9.925zm-3.2 7.79v-2.164l3.2-1.827v1.767a.79.79 0 0 1-.411.692L16 17.716zm-1.6.88v-2.13l-1.976 1.129a.808.808 0 0 1-.801 0l-.569-.326L8 15.524v2.192l3.611 1.984a.808.808 0 0 0 .778 0l2.011-1.105zm-8-3.985v2.226l-1.188-.653a.79.79 0 0 1-.412-.692v-1.795l1.6.914zm-1.6-2.742 4 2.285v-1.985l-4-2.275v1.975zM16 13.724v-1.971l-3.166 1.808a1.689 1.689 0 0 1-1.634.022l-.8-.475v1.959l1.224.699a.807.807 0 0 0 .8 0L16 13.724z","fill":"#2B2F35"}));
}

IconBetBuilder.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconBetBuilder;

IconBetBuilder.default = IconBetBuilder;
